import { FC, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Tabs, Tab } from '@abtasty/design-system';
import { useSegmentTrack } from '@application/hooks/useSegment/useSegment';
import { NavigationItem } from '../types';
import { useIsMobile } from '@src/application/hooks/useIsMobile';
import { EventNotification } from '../EventNotification/EventNotification';
import styles from './Navigation.module.scss';

export const SESSION_STORAGE_SAVED_NAV = 'ABTastyQA_Nav' as const;

export const Navigation: FC<{ items: NavigationItem[] }> = ({ items }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const segmentTrack = useSegmentTrack();

  useEffect(() => {
    try {
      window.sessionStorage.setItem(SESSION_STORAGE_SAVED_NAV, pathname);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
      // ignore the error here
    }
  }, [pathname]);

  const isMobile = useIsMobile();

  const tabs = items.reduce<JSX.Element[]>((tabs, { name, path, key, desktopOnly }) => {
    if ((!desktopOnly || !isMobile) && name) {
      const activeTab = path === pathname;
      return [
        ...tabs,
        <Tab
          key={`${key}-nav`}
          active={activeTab}
          onClick={() => {
            segmentTrack(` Qa - Click ${key.toLowerCase()} tab`);
            navigate(path);
          }}
        >
          <div className={styles.navItem}>
            {name}
            {key === 'events' && <EventNotification activeTab={activeTab} />}
          </div>
        </Tab>,
      ];
    }
    return tabs;
  }, []);

  return <Tabs variant="primary">{tabs}</Tabs>;
};
